import React from 'react';
import { extensions } from '@yola/ws-sdk';
import common from '../constants/common';
import canBeMovedBackward from '../helpers/can-be-moved-backward';
import canBeMovedForward from '../helpers/can-be-moved-forward';
import MoveForward from '../components/move-forward';

const { MOVE_FORWARD } = common;

const layerForwardControl = {
  id: MOVE_FORWARD,
  trigger: <MoveForward />,
  matches(liveElement) {
    const settings = extensions.accessors.getExtensionSettings(common.slug);
    const isMatched = liveElement.matches(settings.elementToReorderSelector);

    if (!isMatched) return false;

    return canBeMovedBackward(liveElement) || canBeMovedForward(liveElement);
  },
  priority: 39,
};

export default layerForwardControl;
